import React from 'react';
import TopicsPageLayout from '../components/TopicsPageLayout.jsx';
import TopicsRouter from '../components/TopicsRouter.jsx';
import topicData from './chatplatforms.json';

const Chatplatforms = () => {
  return (
    <div className="topic-page-container">
        <TopicsPageLayout
            
            description="Messaging apps, digital communication, and online etiquette. B2 level grammar, vocabulary, and discussion exercises."
            level="B2"
            title="Chat Platforms"
            image="/Images/chatapps.webp"
            seoTitle="Free English Lesson Plans: Chat Platforms"
            seoDescription="Messaging apps, digital communication, and online etiquette. B2 level grammar, vocabulary, and discussion exercises."
        >
            {topicData.map((section, index) => (
                <div key={index} className="lesson-section-wrapper">
                    <TopicsRouter sectionData={section} />
                </div>
            ))}
        </TopicsPageLayout>
    </div>
  );
};

export default Chatplatforms;


